export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '16px 20px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const titleStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const rowsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

export const rowStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
};

export const chipColumnStyles = {
  display: 'flex',
  flexShrink: 0,
  minWidth: '140px',
};

export const rowTextStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const sectionsLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const amountStyles = {
  marginLeft: 'auto',
  flexShrink: 0,
  whiteSpace: 'nowrap',
};
